// IMOTEpS — Centre de recherche / Chapitre 7
// Auto-split from chapters.js (Feb 2026 refactor)

export const chapter07 = {
  id: 7,
  slug: "omarthrose-arthroplastie",
  color: "#8B2252",
  title: "Omarthrose et arthroplastie de l'épaule",
  subtitle: "Prothèse anatomique, inversée, hémiarthroplastie — indications et résultats",
  region: "Épaule",
  readingMin: 17,
  summary:
    "Physiopathologie de l'omarthrose primitive et secondaire (cuff tear arthropathy), classification de Samilson-Prieto, indications de la prothèse totale anatomique vs inversée, scores fonctionnels (Constant, ASES, SSV), complications et reprises.",
  sections: [
    {
      heading: "1. Physiopathologie",
      body: "L'omarthrose primitive est une dégénérescence cartilagineuse pure. L'omarthrose secondaire s'observe après instabilité chronique, fracture, rupture massive de coiffe (cuff tear arthropathy de Neer) ou polyarthrite rhumatoïde.",
    },
    {
      heading: "2. Classification de Samilson-Prieto",
      list: [
        "Stade I : ostéophyte inférieur < 3 mm",
        "Stade II : ostéophyte 3–7 mm + sclérose",
        "Stade III : ostéophyte > 7 mm + interligne pincé",
      ],
    },
    {
      heading: "3. Choix de la prothèse",
      body: "La prothèse anatomique est indiquée en cas de coiffe fonctionnelle. La prothèse inversée (concept de Grammont) est devenue le gold standard en cas de coiffe non fonctionnelle, de cuff tear arthropathy ou chez le sujet âgé. L'hémiarthroplastie n'a quasiment plus d'indications hormis les fractures complexes du sujet jeune.",
    },
    {
      heading: "4. Résultats fonctionnels",
      body: "Les scores Constant, ASES et SSV s'améliorent en moyenne de 30 à 50 points après prothèse inversée. La survie prothétique atteint 90–94 % à 10 ans dans les séries publiées.",
    },
    {
      heading: "5. Complications",
      list: [
        "Notch scapulaire (10–20 %, conception modulaire)",
        "Instabilité (3–5 %)",
        "Infection (1–2 %, Cutibacterium acnes++)",
        "Fracture péri-prothétique acromiale (3–8 % en inversée)",
        "Descellement glénoïdien (anatomique, 2–5 % à 10 ans)",
      ],
    },
  ],
  references: [
    { id: 1, text: "Grammont PM, Baulot E. Delta shoulder prosthesis: design and results. Orthopedics. 1993;16(1):65-8." },
    { id: 2, text: "Samilson RL, Prieto V. Dislocation arthropathy of the shoulder. JBJS Am. 1983;65(4):456-60.", pubmed: "6833319" },
  ],
};
